export const fmtNum = (n: number, digits = 0) =>
  new Intl.NumberFormat('ru-RU', {
    minimumFractionDigits: 0,
    maximumFractionDigits: digits,
  }).format(n);

export const clamp = (n: number, min: number, max: number) =>
  Math.min(Math.max(n, min), max);

export const mealTypeLabel: Record<string, string> = {
  breakfast: 'Завтрак',
  lunch: 'Обед',
  dinner: 'Ужин',
  snack: 'Перекус',
};

export const goalLabel: Record<string, string> = {
  lose: 'Похудение',
  maintain: 'Поддержание',
  gain: 'Набор массы',
};

export const activityLabel: Record<string, string> = {
  sedentary: 'Минимальная',
  light: 'Лёгкая',
  moderate: 'Средняя',
  active: 'Высокая',
  very_active: 'Очень высокая',
};
/** Возвращает активные цели — кастомные если включены, иначе авто */
export function getActiveTargets(profile: {
  use_custom_targets?: boolean;
  custom_calories?: number;
  custom_protein_g?: number;
  custom_fat_g?: number;
  custom_carbs_g?: number;
  daily_calories?: number;
  daily_protein_g?: number;
  daily_fat_g?: number;
  daily_carbs_g?: number;
}) {
  if (profile.use_custom_targets) {
    return {
      calories: profile.custom_calories ?? profile.daily_calories ?? 2000,
      protein: profile.custom_protein_g ?? profile.daily_protein_g ?? 100,
      fat: profile.custom_fat_g ?? profile.daily_fat_g ?? 70,
      carbs: profile.custom_carbs_g ?? profile.daily_carbs_g ?? 250,
    };
  }
  return {
    calories: profile.daily_calories ?? 2000,
    protein: profile.daily_protein_g ?? 100,
    fat: profile.daily_fat_g ?? 70,
    carbs: profile.daily_carbs_g ?? 250,
  };
}
/**
 * Расчёт процента жира по методике U.S. Navy — МЕТРИЧЕСКАЯ версия (см).
 *
 * ⚠️ Коэффициенты 86.010 / 163.205 (популярная запись формулы) работают ТОЛЬКО с дюймами.
 * До 30.07.2026 они применялись к сантиметрам, из-за чего % жира завышался примерно
 * на 6-7 п.п. у мужчин и на 20-26 п.п. у женщин (женщины упирались в потолок 60%).
 *
 * Мужчины: 495 / (1.0324 − 0.19077 × log10(талия − шея) + 0.15456 × log10(рост)) − 450
 * Женщины: 495 / (1.29579 − 0.35004 × log10(талия + бёдра − шея) + 0.22100 × log10(рост)) − 450
 *
 * «Бёдра» здесь = обхват таза в самом широком месте (через ягодицы), а не обхват ноги.
 */
export function calculateBodyFatNavy(params: {
  sex: 'male' | 'female';
  height_cm: number;
  neck_cm: number;
  waist_cm: number;
  hips_cm?: number;
}): number | null {
  const { sex, height_cm, neck_cm, waist_cm, hips_cm } = params;

  if (!height_cm || !neck_cm || !waist_cm) return null;

  const clamp = (bf: number) =>
    Number.isFinite(bf) ? Math.max(2, Math.min(60, +bf.toFixed(1))) : null;

  try {
    if (sex === 'male') {
      const diff = waist_cm - neck_cm;
      if (diff <= 0) return null;
      const bf = 495 / (1.0324 - 0.19077 * Math.log10(diff) + 0.15456 * Math.log10(height_cm)) - 450;
      return clamp(bf);
    } else {
      if (!hips_cm) return null;
      const diff = waist_cm + hips_cm - neck_cm;
      if (diff <= 0) return null;
      const bf = 495 / (1.29579 - 0.35004 * Math.log10(diff) + 0.22100 * Math.log10(height_cm)) - 450;
      return clamp(bf);
    }
  } catch {
    return null;
  }
}
